export const TEXT_BLOCK_ID = '61fb5f323f30e059b82c3da8';

// El backend seguirá almacenando este contenido como un bloque Texto. Esta
// marca permite que el frontend lo trate como el nuevo bloque constructor HTML.
export const HTML_BLOCK_MARKER = 'nimbus-bc-html:v1';

export const isHtmlBlock = (content) =>
  content?.bloque?._id === TEXT_BLOCK_ID &&
  content?.html === HTML_BLOCK_MARKER;

export const createHtmlBlockPayload = ({ order, origin, originId }) => ({
  origen: origin,
  id_origen: originId,
  bloque: {
    _id: TEXT_BLOCK_ID,
  },
  orden: order,
  texto: '',
  html: HTML_BLOCK_MARKER,
  ruleta: '!bg-[#fff]',
});

export const buildHtmlDocument = (html = '') => {
  if (/<!doctype\s+html|<html(?:\s|>)/i.test(html)) {
    return html;
  }

  return `<!doctype html>
<html lang="es">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<body>${html}</body>
</html>`;
};
